﻿import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from '@mui/material';

export default function PromoItemModal({
  open,
  handleClose,
  item,
  itemData,
  availableColors,
  availableSizes,
  addToCart,
}) {
  const [selectedColor, setSelectedColor] = useState('');
  const [selectedSize, setSelectedSize] = useState('');
  const [quantity, setQuantity] = useState(1);

  const handleColorChange = (e) => {
    setSelectedColor(e.target.value);
  };

  const handleSizeChange = (e) => {
    setSelectedSize(e.target.value);
  };

  const handleQuantityChange = (e) => {
    setQuantity(e.target.value);
  };

  const handleAddToCart = () => {
    const selectedColorObj = availableColors.find((color) => color.ID === selectedColor);
    const selectedSizeObj = availableSizes.find((size) => size.ID === selectedSize);

    addToCart({
      id: item.ID,
      title: itemData.title,
      price: itemData.pricePerUnit,
      color: selectedColorObj ? selectedColorObj.ColorName : '',
      size: selectedSizeObj ? selectedSizeObj.SizeName : '',
      quantity,
    });
    handleClose();
  };

  useEffect(() => {
    if (open && availableColors.length > 0) {
      setSelectedColor(availableColors[0].ID);
    }
  }, [open, availableColors]);

  useEffect(() => {
    if (open && availableSizes.length > 0) {
      setSelectedSize(availableSizes[0].ID);
    }
  }, [open, availableSizes]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          minHeight: '10%',
          maxHeight: '40%',
          minWidth: '10%',
          maxWidth: '30%',
          overflow: 'hidden',
        },
      }}
    >
      <DialogTitle style={{ textAlign: 'center' }}>{itemData.title}</DialogTitle>
      <DialogContent style={{ overflow: 'hidden' }}>
        <Typography variant="h6" component="p" align="center">
          ${(itemData.pricePerUnit * quantity).toFixed(2)}
        </Typography>
        {availableColors.length > 0 && (
          <FormControl fullWidth variant="outlined" margin="normal">
            <InputLabel>Color</InputLabel>
            <Select value={selectedColor} onChange={handleColorChange} label="Color">
              {availableColors.map((color) => (
                <MenuItem key={color.ID} value={color.ID}>
                  {color.ColorName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        {availableSizes.length > 0 && (
          <FormControl fullWidth variant="outlined" margin="normal">
            <InputLabel>Size</InputLabel>
            <Select value={selectedSize} onChange={handleSizeChange} label="Size">
              {availableSizes.map((size) => (
                <MenuItem key={size.ID} value={size.ID}>
                  {size.SizeName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <TextField
          fullWidth
          variant="outlined"
          margin="normal"
          label="Quantity"
          type="number"
          value={quantity}
          onChange={handleQuantityChange}
          inputProps={{ min: 1 }}
        />
        <Button onClick={handleAddToCart} variant="contained" color="primary" fullWidth>
          Add to Cart
        </Button>
      </DialogContent>
    </Dialog>
  );
}
